(function () {
  function roundQty(value, unit) {
    var u = (unit || '').toLowerCase();
    var piece = u === '' || u.indexOf('szt') === 0;
    if (piece) {
      value = Math.round(value);
      if (value < 1) value = 1;
    } else if (value >= 100) {
      value = Math.round(value / 5) * 5;
    } else if (value >= 10) {
      value = Math.round(value);
    } else {
      value = Math.round(value * 4) / 4;
    }
    return value;
  }

  function initServings(root) {
    var out = root.querySelector('[data-servings]');
    if (!out) return;
    var base = parseFloat(out.dataset.baseServings);
    if (!base || base < 1) base = 1;
    var current = base;
    var qtys = root.querySelectorAll('[data-base]');

    function apply() {
      out.textContent = current;
      var factor = current / base;
      qtys.forEach(function (el) {
        var b = parseFloat(el.dataset.base.replace(',', '.'));
        if (isNaN(b)) return;
        var unit = el.dataset.unit || '';
        var n = roundQty(b * factor, unit);
        var label = unit ? UrbUnits.unit(n, unit) : '';
        el.textContent = UrbUnits.formatAmount(n) + (label ? ' ' + label : '');
      });
    }

    root.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        current = Math.min(24, Math.max(1, current + parseInt(btn.dataset.step, 10)));
        apply();
      });
    });

    apply();
  }

  function initJump(root) {
    var jump = root.querySelector('[data-jump]');
    var hero = root.querySelector('[data-hero]');
    var panel = root.querySelector('[data-panel]');
    if (!jump || !hero || !panel || !('IntersectionObserver' in window)) return;
    var heroGone = false;
    var panelReached = false;

    function sync() {
      jump.hidden = !(heroGone && !panelReached);
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      heroGone = !e.isIntersecting && e.boundingClientRect.top < 0;
      sync();
    }).observe(hero);

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      panelReached = e.isIntersecting || e.boundingClientRect.top < 0;
      sync();
    }, { rootMargin: '0px 0px -35% 0px' }).observe(panel);
  }

  function initCook(root) {
    var dlg = root.querySelector('[data-cook]');
    var openBtn = root.querySelector('[data-cook-open]');
    if (!dlg || !openBtn) return;
    if (!('HTMLDialogElement' in window) || typeof dlg.showModal !== 'function') {
      openBtn.hidden = true;
      return;
    }

    var steps = Array.prototype.map.call(root.querySelectorAll('[data-krok]'), function (li) {
      return li.textContent.trim();
    });
    if (!steps.length) {
      openBtn.hidden = true;
      return;
    }

    var stepEl = dlg.querySelector('[data-cook-step]');
    var progEl = dlg.querySelector('[data-cook-progress]');
    var prev = dlg.querySelector('[data-cook-prev]');
    var next = dlg.querySelector('[data-cook-next]');
    var index = 0;
    var lock = null;

    function render() {
      stepEl.textContent = steps[index];
      progEl.textContent = window.urbStrings.cookProgress.replace('[current]', index + 1).replace('[total]', steps.length);
      prev.disabled = index === 0;
      next.textContent = index === steps.length - 1 ? window.urbStrings.cookFinish : window.urbStrings.cookNext;
    }

    function acquireLock() {
      if (!('wakeLock' in navigator)) return;
      navigator.wakeLock.request('screen').then(function (l) {
        lock = l;
      }).catch(function () {});
    }

    function releaseLock() {
      if (lock) {
        lock.release().catch(function () {});
        lock = null;
      }
    }

    openBtn.addEventListener('click', function () {
      index = 0;
      render();
      dlg.showModal();
      acquireLock();
    });

    next.addEventListener('click', function () {
      if (index >= steps.length - 1) {
        dlg.close();
      } else {
        index += 1;
        render();
      }
    });

    prev.addEventListener('click', function () {
      if (index > 0) {
        index -= 1;
        render();
      }
    });

    dlg.querySelector('[data-cook-close]').addEventListener('click', function () {
      dlg.close();
    });

    dlg.addEventListener('close', releaseLock);

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') next.click();
      if (e.key === 'ArrowLeft') prev.click();
    });

    document.addEventListener('visibilitychange', function () {
      if (dlg.open && document.visibilityState === 'visible') acquireLock();
    });
  }

  function init(root) {
    if (!root || root.dataset.urbRecipeInit) return;
    root.dataset.urbRecipeInit = '1';
    initServings(root);
    initJump(root);
    initCook(root);
  }

  function boot() {
    document.querySelectorAll('[data-urb-recipe]').forEach(init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-urb-recipe]');
    if (root) init(root);
  });
})();